import React from 'react'
import Header from '../Home/Header';
import Hardware from './Hardware';
import Footer from '../Home/Footer';
import HardwareProducts from '../Product/HardwareProducts'
const Product = () => {
  return (
    <div>
         <Header />
         <HardwareProducts />
         <Hardware />
         <Footer />
    </div>
  )
}

export default Product